export var CallRequestAction;
(function (CallRequestAction) {
    CallRequestAction["REQUEST"] = "REQUEST";
    CallRequestAction["WITHDRAW"] = "WITHDRAW";
    CallRequestAction["ACCEPT"] = "ACCEPT";
    CallRequestAction["LISTEN"] = "LISTEN";
    CallRequestAction["REJECT"] = "REJECT";
})(CallRequestAction || (CallRequestAction = {}));
//# sourceMappingURL=call-request-action.enum.js.map